import React from 'react'
import "../styles/titleBar.css"
import { TooltipIcon } from '../Pages/Components/Tooltips/TooltipInfos'

export const TitleBar = (props) => {
    return (
        <div className='container-title' style={{display: 'flex', alignItems: 'center', gap: 8 }}>
            <h2 className='title'>
                {props.title}
            </h2>
            {props.tooltipKey && <TooltipIcon tooltipKey={props.tooltipKey} />}
        </div>
    )
}
